<template>
  <div class="card-details__type-text" v-html="typeText"></div>
</template>

<script>
export default {
  name: 'CardModalDetailsTypeText',

  props: {
    typeText: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>
.card-details__type-text h4 {
  color: var(--c-secondary-700);
  margin: 10px 0 5px;
}

.card-details__type-text span {
  color: var(--c-secondary-700);
  margin: 10px 0 5px;
}
</style>
